import CommentBoxContentWrapper from './CommentBoxContentWrapper';
import CommentBoxContentWrapperV2 from '../../lego.editor_comment/CommentBoxContentWrapper';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CommentBoxContentWrapperV2
})(CommentBoxContentWrapper);

//# sourceMappingURL=index.js.map